module.exports = __webpack_public_path__ + "img/auth-pic.a29b99e3.png";